// DashboardLineChart.jsx
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const MESES = [
  "01","02","03","04","05","06",
  "07","08","09","10","11","12"
];

function normalizarMeses(data) {
  const map = Object.fromEntries(
    data.map(item => [item.mes.padStart(2, "0"), item.promedio_por_dia])
  );

  return MESES.map(mes => ({
    mes,
    promedio_por_dia: map[mes] ?? 0,
  }));
}
const MESES_LABEL = {
  "01": "Ene", "02": "Feb", "03": "Mar", "04": "Abr",
  "05": "May", "06": "Jun", "07": "Jul", "08": "Ago",
  "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dic",
};

export default function DashboardLineChart({ data }) {
  if (!data || data.length === 0) return null;

  const dataNormalizada = normalizarMeses(data);

  return (
    <div className="dashboard-chart">
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={dataNormalizada}>
          <XAxis
            dataKey="mes"
            tickFormatter={(mes) => MESES_LABEL[mes]}
          />
          <YAxis />
          <Tooltip
            labelFormatter={(mes) => MESES_LABEL[mes]}
          />
          <Line
            type="monotone"
            dataKey="promedio_por_dia"
            stroke="#22c55e"
            strokeWidth={3}
            dot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
